var _path, _path2, _path3, _path4, _path5, _rect, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBankLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 65,
    viewBox: "0 0 63 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99121 27.8013V51.4376",
    stroke: "#EBF3FF",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5371 27.8013V51.4376",
    stroke: "#EBF3FF",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7646 27.8013V51.4376",
    stroke: "#EBF3FF",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7871 27.8013V51.4376",
    stroke: "#EBF3FF",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.08246 18.8252L31.3539 1.79687C31.679 1.60108 32.0868 1.60615 32.4069 1.80997L59.1502 18.8383C59.994 19.3756 59.6134 20.6818 58.6131 20.6818H3.59841C2.58509 20.6818 2.21442 19.3481 3.08246 18.8252Z",
    fill: "#EBF3FF",
    stroke: "#EBF3FF",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.08203,
    y: 56.8694,
    width: 55.6136,
    height: 6.86364,
    rx: 2,
    fill: "#EBF3FF",
    stroke: "#EBF3FF",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6631 12.3342C35.6631 14.4253 33.968 16.1204 31.877 16.1204C29.7859 16.1204 28.0908 14.4253 28.0908 12.3342C28.0908 10.2432 29.7859 8.5481 31.877 8.5481C33.968 8.5481 35.6631 10.2432 35.6631 12.3342Z",
    stroke: "#001F4B",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankLight);
export default __webpack_public_path__ + "static/media/bank-light.8062c78a.svg";
export { ForwardRef as ReactComponent };